import React, { ReactNode } from "react";

type FeatureBannerProps = {
  children: ReactNode;
  className?: string;
};

const FeatureBanner = ({ children, className = "" }: FeatureBannerProps) => {
  return (
    <div
      className={`relative overflow-hidden rounded border border-[#1976d2] bg-[#1976d2] px-4 py-3 text-white ${className}`.trim()}
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <span className="absolute right-[11%] top-[20%] h-1.5 w-1.5 rounded-full bg-white/65" />
        <span className="absolute right-[22%] top-[13%] h-1 w-1 rounded-full bg-white/35" />
        <span className="absolute right-[30%] top-[28%] h-0.5 w-0.5 rounded-full bg-white/45" />
        <span className="absolute right-[19%] top-[42%] h-2 w-2 rounded-full bg-white/30" />
        <span className="absolute right-[8%] top-[52%] h-1 w-1 rounded-full bg-white/55" />
        <span className="absolute right-[28%] top-[56%] h-1.5 w-1.5 rounded-full bg-white/25" />
        <span className="absolute right-[15%] top-[72%] h-0.5 w-0.5 rounded-full bg-white/60" />
        <span className="absolute right-[36%] top-[69%] h-1 w-1 rounded-full bg-white/30" />
        <span className="absolute right-[5%] top-[30%] h-0.5 w-0.5 rounded-full bg-white/40" />
        <span className="absolute right-[42%] top-[18%] h-0.5 w-0.5 rounded-full bg-white/25" />
        <span className="absolute right-[15%] top-[8%] h-1.5 w-1.5 rounded-full bg-white/25" />
        <span className="absolute right-[40%] top-[39%] h-1 w-1 rounded-full bg-white/35" />
        <span className="absolute right-[34%] top-[48%] h-0.5 w-0.5 rounded-full bg-white/55" />
        <span className="absolute right-[24%] top-[65%] h-1 w-1 rounded-full bg-white/45" />
        <span className="absolute right-[45%] top-[77%] h-0.5 w-0.5 rounded-full bg-white/35" />
        <span className="absolute right-[3%] top-[78%] h-1.5 w-1.5 rounded-full bg-white/25" />
        <span className="absolute right-[27%] top-[82%] h-0.5 w-0.5 rounded-full bg-white/50" />
        <span className="absolute right-[48%] top-[58%] h-1 w-1 rounded-full bg-white/20" />
        <span className="absolute right-[7%] top-[12%] h-0.5 w-0.5 rounded-full bg-white/45" />
        <span className="absolute right-[17%] top-[28%] h-1 w-1 rounded-full bg-white/25" />
        <span className="absolute right-[39%] top-[8%] h-0.5 w-0.5 rounded-full bg-white/35" />
        <span className="absolute right-[32%] top-[15%] h-1.5 w-1.5 rounded-full bg-white/20" />
        <span className="absolute right-[3%] top-[43%] h-1 w-1 rounded-full bg-white/35" />
        <span className="absolute right-[12%] top-[45%] h-0.5 w-0.5 rounded-full bg-white/55" />
        <span className="absolute right-[43%] top-[31%] h-1 w-1 rounded-full bg-white/25" />
        <span className="absolute right-[25%] top-[36%] h-0.5 w-0.5 rounded-full bg-white/50" />
        <span className="absolute right-[46%] top-[45%] h-1.5 w-1.5 rounded-full bg-white/18" />
        <span className="absolute right-[10%] top-[61%] h-0.5 w-0.5 rounded-full bg-white/45" />
        <span className="absolute right-[21%] top-[52%] h-1 w-1 rounded-full bg-white/30" />
        <span className="absolute right-[42%] top-[66%] h-0.5 w-0.5 rounded-full bg-white/40" />
        <span className="absolute right-[4%] top-[67%] h-1 w-1 rounded-full bg-white/30" />
        <span className="absolute right-[31%] top-[76%] h-1.5 w-1.5 rounded-full bg-white/18" />
        <span className="absolute right-[19%] top-[88%] h-0.5 w-0.5 rounded-full bg-white/45" />
        <span className="absolute right-[38%] top-[88%] h-1 w-1 rounded-full bg-white/25" />
      </div>
      <div className="relative z-10 [&_h3]:text-[13px] [&_h3]:font-bold [&_h3]:leading-4 [&_h3]:text-white [&_p]:text-[12px] [&_p]:leading-[1.35] [&_p]:text-blue-50 [&_li]:text-[12px] [&_li]:leading-[1.35] [&_li]:text-blue-50 [&_ul]:space-y-0.5">
        {children}
      </div>
    </div>
  );
};

export default FeatureBanner;
